import { FleekError } from './FleekError';

type FleekFunctionPathNotValidErrorOptions = {
  path: string;
};

export class FleekFunctionPathNotValidError extends FleekError<FleekFunctionPathNotValidErrorOptions> {
  public name = 'FleekFunctionPathNotValidError';

  toString = () => {
    return `File or folder at path, ${this.data.path} is invalid. Please refer to our documentation for more information on function file conventions.`;
  };
}
